import { useState } from "react";
import { BsSearch } from "react-icons/bs";

import {
  transformSearchToSearchTerm,
  transformRequestDataToResultsTableProps,
} from "@Components/Search/Search";
import { Deal } from "@Types/deal";
import Loading from "@Components/Loading";
import useDebounce from "@Hooks/useDebounce";
import useGlobalSearch from "@Hooks/useGlobalSearch";
import TextField from "@Components/Inputs/TextField";
import { SearchState } from "@Components/Search/types";
import ApplicationPreview from "@Pages/Applications/Application/ApplicationPreview";

import styles from "./ChatSearch.module.scss";

export type ChatSearchProps = { handleSelectDeal: (deal: Deal) => void };

const ChatSearch = ({ handleSelectDeal }: ChatSearchProps) => {
  const [state, setState] = useState<SearchState>({ value: "", focus: false });
  const debouncedValue = useDebounce<SearchState>(state, 1000);
  const requestResult = useGlobalSearch(
    transformSearchToSearchTerm(debouncedValue.value)
  );
  const searchResult = transformRequestDataToResultsTableProps(requestResult);

  return (
    <div>
      <div className={styles.container}>
        <div className={styles.iconContainer}>
          <BsSearch size={22} className={styles.icon} />
        </div>
        <div className={styles.textField}>
          <TextField
            value={state.value}
            inputStyle={{
              color: "#5E5D65",
              fontWeight: 400,
              borderTopRightRadius: 5,
              borderBottomRightRadius: 5,
              borderBottomLeftRadius: 0,
              borderTopLeftRadius: 0,
              border: 0,
              paddingLeft: "5px",
            }}
            type="text"
            showPlaceHolderTop={false}
            placeholder="Search loan"
            onChange={(e) =>
              setState((prev) => ({ ...prev, value: e.target.value }))
            }
            onFocus={() => setState((prev) => ({ ...prev, focus: true }))}
            onBlur={() => setState((prev) => ({ ...prev, focus: false }))}
          />
        </div>
      </div>
      {searchResult.data.loading && state.value.length > 2 ? (
        <div className={styles.loading}>
          <Loading size={25} />
        </div>
      ) : searchResult.data.data?.length ? (
        searchResult.data.data.map((deal) => (
          <ApplicationPreview
            deal={deal}
            selectType="button"
            key={deal._id}
            handleClick={handleSelectDeal}
          />
        ))
      ) : null}
    </div>
  );
};
export default ChatSearch;
